export default "__VITE_ASSET__CJKguScw__"